module.exports = __webpack_public_path__ + "img/about-main-2.918c13a3.webp";